export const ServiceData = [
  {
    title: `<span class='extra'>שירות תוכן ו/או מידע בתשלום חד פעמי</span>`,
    services: [
      {
        value: `קבלת או הורדת תוכן באמצעות האינטרנט, צפייה בו ו/או האזנה לו באופן חד פעמי (כגון: הורדה או צפייה בסרט וידאו, האזנה לשיר, הורדת רינגטון, הורדת סרט וידאו, הורדת משחק והכול באופן חד פעמי)`,
        type: 'zotDownConInd',
      },
      {
        value: `שליחת מסרון בתשלום מיוחד לשם הצבעה במסגרת תוכנית המשודרת בטלוויזיה באופן חד פעמי (כגון: הצבעה לתוכנית ריאליטי, באופן
        חד פעמי)`,
        type: 'zotVoteInd',
      },
      {
        value: `מתן תרומה באמצעות שליחת מסרון באופן חד פעמי (כגון: תרומה לאגודה באופן חד פעמי)`,
        type: 'zotDonateInd',
      },
      {
        value: `קבלת מידע שימושי באופן חד פעמי (כגון: מידע על קווי תחבורה, בעלי מקצוע, מידע פיננסי, הודעה בעניין קבלת דבר דואר רשום והכול באופן חד פעמי)`,
        type: 'zotInfoInd',
      },
      {
        value: `קבלת תוכן באופן חד פעמי (כגון: חידון, הגרלה, סקר, משאל, תחזית אסטרולוגית, קבלת קישור להורדת סרטון וידאו והכל באופן חד פעמי)`,
        type: 'zotRecContInd',
      },
    ],
  },
  {
    title: `<span class='extra'>שירות תוכן ו/או מידע בתשלום מתמשך - מנוי</span>`,
    services: [
      {
        value: `קבלת או הורדת תוכן באמצעות האינטרנט צפייה בו ו/או האזנה לו שלא באופן חד פעמי (כגון מנוי להורדה או צפייה בסרט וידיאו, מנוי לשירות מוזיקה, מנוי להורדת רינגטונים, מנוי להורדת סרטי וידאו ומנוי להורדת משחקים)`,
        type: 'zcnDownConInd',
      },
      {
        value: `קבלת תוכן ו/או מידע שלא באופן חד פעמי (כגון: מנוי לקבלת עדכוני חדשות, מנוי לקבלת תוצאות ספורט, מנוי לקבלת שאלות טריוויה , מנוי לקבלת מתכוני דיאטה)`,
        type: 'zcnRecContInd',
      },
    ],
  },
  {
    title: `<span class='extra'> גישה לשירות פרימיום </span>`,
    services: [
      {
        value: `הכולל השמעת תוכן קולי או הצגת תוכן חזותי, כגון: מידע, בידור, ייעוץ, שירות היכרויות, השתתפות בתחרויות וכו', הניתן באמצעות חיוג למספר הכולל את קידומות החיוג 1-900 ו-1-901`,
      },
      {
        value: `מספרים בקידומת 1-900 בתעריף של עד 50 אג' לדקה ולא יותר מ-30 ₪ לשיחה כולה`,
        type: 'premium0Ind',
      },
      {
        value: ` מספרים בקידומת 1-901 בתעריף שאינו עולה על 50 ₪ לשיחה כולה`,
        type: 'premium1Ind',
      },
    ],
  },
  {
    title: `<span class='extra'> שירות שיחות לחו"ל</span>`,
    services: [
      {
        value: ``,
        type: 'intlInd',
      },
    ],
  },
  {
    title: `<span class='extra'>פרסום ב-144</span>`,
    services: [
      {
        value: `פרסום מספר/י הטלפון המחויב/ים בחשבון , במודיעין הטלפוני (" 144 ") ובאינטרנט.`,
        type: 'b144Ind',
      },
    ],
  },
];
